(function () {
  const collectionSelector = '.featured-collection[data-context="featured-collection"]';
  const errorMessage = 'Could not complete this action in the app. Please try again.';

  function waitForBridge() {
    if (window.Tapcart?.isInitialized) return Promise.resolve(window.Tapcart);

    return new Promise((resolve, reject) => {
      const timeout = window.setTimeout(() => {
        window.removeEventListener('webbridge-loaded', onLoaded);
        reject(new Error('Tapcart Web Bridge did not initialize'));
      }, 3000);

      function onLoaded() {
        if (!window.Tapcart?.isInitialized) return;
        window.clearTimeout(timeout);
        window.removeEventListener('webbridge-loaded', onLoaded);
        resolve(window.Tapcart);
      }

      window.addEventListener('webbridge-loaded', onLoaded);
      onLoaded();
    });
  }

  function tapcartAction(action, data) {
    return new Promise((resolve, reject) => {
      action(data, { onSuccess: resolve, onError: reject });
    });
  }

  function showError(card) {
    let message = card.querySelector('.mvfc-cart-error');
    if (!message) {
      message = document.createElement('p');
      message.className = 'errors mvfc-cart-error';
      message.setAttribute('role', 'alert');
      card.querySelector('.grid-product__content').appendChild(message);
    }
    message.textContent = errorMessage;
  }

  document.addEventListener('click', async (event) => {
    const card = event.target.closest(`${collectionSelector} .grid-product[data-product-id]`);
    if (!card || !theme.isTapcartWebView()) return;

    const size = event.target.closest('.grid-item-custom__size-swatch[data-variant]');
    const link = event.target.closest('a[href*="/products/"]');
    const quickShop = event.target.closest('.quick-product__btn');
    if (!size && !link && !quickShop) return;
    if (link && (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (size?.classList.contains('grid-item-custom__size-swatch--disabled')) return;
    if (card.dataset.tapcartBusy === 'true') return;

    card.dataset.tapcartBusy = 'true';
    if (size) size.classList.add('btn--loading');
    const previousError = card.querySelector('.mvfc-cart-error');
    if (previousError) previousError.remove();

    try {
      const tapcart = await waitForBridge();

      if (size) {
        await tapcartAction(tapcart.actions.addToCart, {
          lineItems: [{ variantId: size.dataset.variant, quantity: 1 }]
        });
        try {
          tapcart.actions.openCart();
        } catch (error) {
          console.error('MVFC Tapcart cart navigation failed:', error);
        }
      } else {
        await tapcartAction(tapcart.actions.openProduct, {
          productId: card.dataset.productId
        });
      }
    } catch (error) {
      console.error('MVFC Tapcart action failed:', error);
      showError(card);
    } finally {
      card.dataset.tapcartBusy = 'false';
      if (size) size.classList.remove('btn--loading');
    }
  }, true);
})();
